import * as React from "react";
import {useEffect, useState} from "react";
import {Alert, Button, Chip, CircularProgress, Paper, Typography} from "@mui/material";
import {post, postInvoice} from "../utils/post";
import {useNavigate, useParams} from "react-router-dom";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import StarIcon from "@mui/icons-material/Star";
import CheckIcon from "@mui/icons-material/Check";
import SplitButton from "../utils/ButtonGroup";

import css from "../css/tariff.module.css";
import {AppComponent} from "../App";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import {storage} from "../utils/localstorage";
import {VKSubscription} from "../components/VKPay";

const Tariff = ({tariff: {id, title, displayPrice, list, errorList, selected, buttonList}}) => {
    const navigate = useNavigate();

    const chooseTariff = async (index) => {
        const {invoice} = await post({method: "invoiceCreate", tariffId: id, months: buttonList[index].months}, true);
        navigate(`/payment/${invoice.id}/`);
    }

    return (
        <Paper
            sx={theme => ({
                background: selected ? theme.palette.success.light : "unset",
                [!selected && "boxShadow"]: "unset",
            })}
            className={selected ? `${css.mainPaper} selected` : css.mainPaper}
        >
            <div className={"badge"} style={{visibility: "hidden", textAlign: "right", marginBottom: 8}}>
                <Chip color={"warning"} icon={<StarIcon/>} label="Самый популярный"/>
            </div>
            <Paper elevation={3} sx={{p: 4}} className={css.tariff}>
                <div>
                    <Typography variant={"body1"} align={"center"}>{title}</Typography>
                    <Typography variant={"h5"} align={"center"}>{displayPrice}</Typography>
                </div>

                <div className={css.lines}>
                    {!!list.length && (
                        <Alert icon={false} severity="info" sx={{p: 0}}>
                            {list.map((line, i) => (
                                <Alert key={i} sx={{pt: 0, pb: 0, whiteSpace: "nowrap"}}
                                       icon={<CheckIcon fontSize="inherit"/>} color={"info"}>
                                    {line}
                                </Alert>
                            ))}
                        </Alert>
                    )}
                    {!!errorList.length && (
                        <Alert icon={false} severity="error" sx={{p: 0}}>
                            {errorList.map((line, i) => (
                                <Alert key={i} sx={{pt: 0, pb: 0, whiteSpace: "nowrap"}} severity={"error"}>
                                    <s>{line}</s>
                                </Alert>
                            ))}
                        </Alert>
                    )}
                </div>

                {buttonList.length > 1 ? (
                    <SplitButton tariffId={id} buttonList={buttonList} onClick={chooseTariff}>
                        <Button id={`chooseTariff-${id}`} variant={"contained"} fullWidth={true}>Выбрать</Button>
                    </SplitButton>
                ) : (
                    <Button id={`chooseTariff-${id}`} onClick={() => chooseTariff(0)} variant={"contained"}
                            fullWidth={true}>Выбрать</Button>
                )}

            </Paper>
        </Paper>
    )
}
export const Tariffs = () => {
    const navigate = useNavigate();
    const [tariffs, setTariffs] = useState(null);

    const items = [
        {
            id: "Start", list: [
                "Интерактивные задачи"
            ], errorList: [
                "Без рекламы",
                "Визуализация решений",
                "Анализ ошибок",
                "Личный план обучения",
                "Система мотивации",
                "Полная статистика",
            ]
        },
        {
            id: "Premium", list: [
                "Бесплатно 7 дней",
                "Без рекламы",
                "Интерактивные задачи",
                "Визуализация решений",
                "Анализ ошибок",
                "Личный план обучения",
                "Система мотивации",
                "Полная статистика",
            ], errorList: [], selected: true
        },
        {
            id: "VIP", list: [
                'То же, что и "Премиум"',
                "Менторская поддержка",
            ], errorList: []
        }
    ]

    useEffect(() => {
        postInvoice({method: "tariffs"}).then(setTariffs);
    }, [])

    if (!tariffs) return;

    items.forEach(item => {
        const tariff = tariffs[item.id];
        item.price = tariff.price;
        item.title = tariff.title;
        item.displayPrice = item.price ? `${item.price.toLocaleString("ru")}${String.fromCharCode(160)}₽ / мес` : "Бесплатно";
        item.buttonList = tariff.items.map(({months, discount}) => ({
            months, discount,
            title: `Оплатить за ${months} мес. ${discount > 0 ? `Скидка ${discount}%` : `Без скидки`}`
        }))
    })

    return (
        <div className={css.container}>
            <Button onClick={() => navigate("/profile")} startIcon={<ArrowBackIosIcon/>} variant={"contained"}
                    className={css.prevButton}>Назад</Button>
            <div className={css.header}>
                <Typography variant={"h4"} align={"center"}>Выберите тариф</Typography>
                <Typography variant={"h5"} align={"center"}>Годовая подписка на 70% дешевле</Typography>
            </div>
            <div className={css.tariffs}>
                {items.map(item => (
                    <Tariff key={item.id} tariff={item}/>
                ))}
            </div>
        </div>
    )
}
const LifePayWidget = ({data: {comment, name, cost, on_success, on_fail, isAutoPay}}) => {
    const [loading, setLoading] = useState(false);
    useEffect(() => {
        const s = document.head.getElementsByClassName("lifepay_script")[0];
        if (!s) {
            const s = document.createElement("script");
            s.className = "lifepay_script";
            s.onload = () => s.setAttribute("loaded", "true");
            document.head.appendChild(s);
            s.type = "text/javascript";
            s.src = "https://partner.life-pay.ru/gui/lifepay_widget/js/lp-widget.js?1234567";
        }
    }, []);

    const onClickHandle = (e) => {
        e.preventDefault();
        if (isAutoPay()) return;
        setLoading(true);
        const s = document.head.getElementsByClassName("lifepay_script")[0];
        const interval = setInterval(() => {
            if (s.getAttribute("loaded") === "true") {
                clearInterval(interval);
                let canSuccess = true;
                let canFail = true;
                let canClose = true;
                const widget = new window.LpWidget({key: "czfB5RcgiaxgiprgzH+TeQNWuM+B9rXFhb8+s5xTcsE=", name, comment, cost,
                    on_success: () => {
                        if (canSuccess) {
                            setLoading(false);
                            canSuccess = false;
                            on_success()
                        }
                    },
                    on_fail: (e) => {
                        if (canFail) {
                            setLoading(false);
                            canFail = false;
                            on_fail(e)
                        }
                    },
                    on_close: () => {
                        if (canClose) {
                            setLoading(false);
                            canClose = false;
                        }
                    },
                });
                widget.render();
            }
        });
    }

    return (
        <>
            {loading && (
                <div style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    top: 0,
                    left: 0,
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    background: "#00000088"
                }}>
                    <CircularProgress/>
                </div>
            )}
            <a className="lifepay_button" href="#" onClick={onClickHandle}>
                <img
                    alt=""
                    id="a1lite_button"
                    style={{border: 0}}
                    src="https://partner.life-pay.ru/gui/images/a1lite_buttons/button_small.png"
                    title="Оплатить"
                />
            </a>
        </>
    )

}
const InvoiceSuccess = ({invoice}) => {
    const navigate = useNavigate();

    const onClick = () => {
        AppComponent.setRestriction();
        navigate("/app");
    }

    return (
        <div className={css.page}>
            <Typography variant={"h1"} align={"center"}>
                <WorkspacePremiumIcon sx={{fontSize: 90}}/>
            </Typography>
            <Typography variant={"h2"} align={"center"} gutterBottom>
                Поздравляем!
            </Typography>
            <Typography variant={"h4"} align={"center"} gutterBottom>
                Ваш тариф "{invoice.tariff}" продлен на {invoice.months} мес.
            </Typography>
            <Button id={"goToProblems"} onClick={onClick} variant={"contained"}>Перейти к задачам</Button>
        </div>
    )
}
const InvoiceFail = () => {
    return (
        <div className={css.page}>
            <Typography variant={"h1"} align={"center"}>
                <WorkspacePremiumIcon sx={{fontSize: 90}}/>
            </Typography>
            <Typography variant={"h2"} align={"center"} gutterBottom>
                Ошибка оплаты
            </Typography>
            <Typography variant={"h3"} align={"center"} gutterBottom>
                К сожалению, что-то пошло не так и ваш заказ не был оплачен
            </Typography>
            <Button id={"retryInvoice"} onClick={() => document.location = document.location} variant={"contained"}>Попоробовать
                еще раз</Button>
        </div>
    )
}
export const Payment = () => {
    const navigate = useNavigate();
    const {invoiceId} = useParams();
    const [invoice, setInvoice] = useState(null);

    const on_success = async () => {
        setInvoice(await postInvoice({method: "success", invoiceId, cost: invoice?.cost}));
    }
    const on_fail = async (options) => {
        setInvoice({options, fail: true});
    }

    useEffect(() => {
        postInvoice({method: "get", invoiceId}).then(async invoice => {
            if (invoice.error) {
                return navigate("/app");
            }
            if (invoice.cost === 0) {
                await on_success({noCostInvoice: true})
            } else {
                setInvoice(invoice);
            }
        });
    }, [])

    if (!invoice) return;
    if (invoice.success) return <InvoiceSuccess invoice={invoice}/>;
    if (invoice.fail) return <InvoiceFail invoice={invoice}/>;

    const isAutoPay = () => {
        invoice.autoPay && on_success({test: true});
        return invoice.autoPay;
    }

    const authData = storage("authData");


    return (
        <div className={css.page}>
            <Button onClick={() => navigate("/payment")} startIcon={<ArrowBackIosIcon/>} variant={"contained"} className={css.prevButton}>Назад</Button>

            <Typography variant={"h4"} gutterBottom align={"center"}>{invoice.name}</Typography>
            {!!invoice.discount && (<Typography variant={"h5"} gutterBottom align={"center"}>
                <span className={css.diagonalStrike}>{invoice.costWithoutDiscount.toLocaleString("ru")}&nbsp;₽</span>
                &nbsp;-{invoice.discount}%
            </Typography>)}
            <Typography variant={"h3"} gutterBottom align={"center"}>
                Всего {invoice.cost.toLocaleString("ru")}&nbsp;₽
            </Typography>


            <LifePayWidget data={{comment: invoice.id, name: invoice.name, cost: invoice.cost, on_success, on_fail, isAutoPay}}/>
        </div>
    )
}
